<template>
  <div>
    <div  class="content">
      <img class="tx" src="@images/icon-rz.png" />
      <span class="tip">实名认证需进行身份核验<br>请刷脸核验</span>
     <button class="u-btn"   @click="clickYz">开始验证</button>
     <span style="color: #1D6DDB;font-size: 16px;" @click="clickBack">暂不核验</span>
    </div>
  </div>
</template>

<script>
import { getAction, postAction } from '@/api/manage'
import { ACCESS_TOKEN,INDEX_MAIN_PAGE_PATH } from '@/store/mutation-types'
import Vue from 'vue'
export default {
  data() {
    return {
      model:{},
      id:'',
    };
  },
  created() {
   this.model = this.$route.query;

  },
 
  methods: {
 
    clickYz(){//上传信息拿到faceid
    Vue.ls.set('smxx', this.model); 
    let url = `/ai/face/recognition/h5/detect-auth?idNumber=${this.model.idNumber}&name=${this.model.name}`;
      postAction(url).then((res) => {
        console.log(res);
        if (res.success) {
          let url = res.result.url;
          window.location.href = url;
        } else {
          this.$toast(res.message)
        }
      })
    },
    clickBack(){
     this.$router.go(-1);
    },
  
   refreshToken(){
    //  let url = '/sys/mlogin/refresh/current/token';
    // this.$http
    //       .post(url)
    //       .then(res => {
    //           // let obj = res.data;
    //           // console.log(res);
    //           // console.log(obj);
    //           // const userInfo = obj.userInfo
    //           // uni.setStorageSync(ACCESS_TOKEN,obj.token);
    //           // this.$u.vuex('userInfo',userInfo);
    //           // this.$u.vuex('roles',obj.roles);
    //     	 })
    //       .catch(res => {
    //         //
    //         if(res.data.token){
    //           let obj = res.data;
    //           const userInfo = obj.userInfo
    //           uni.setStorageSync(ACCESS_TOKEN,obj.token);
    //           this.$u.vuex('userInfo',userInfo);
    //           this.$u.vuex('roles',obj.roles);
    //         }
    //         this.$tip.loaded();
    //       });
   },
 
  }
};
</script>

<style lang="less" scoped>
.content{
  padding: 0 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  
  .tx{
    width: 150px;
    height: 150px;
    margin-top: 76px;
    margin-bottom: 35px;
  }
  
  .tip{
    font-family: PingFangSC-Medium;
    font-weight: 500;
    font-size: 12px;
    color: #1A1A1A;
    text-align: center;
    margin-bottom: 40px;
  }
  .t-checkbox{
    width: 100%;
    color: #f00;
    margin-bottom: 10px;
  }
  
  .u-btn{
    width: 100%;
    height: 40px;
    background: #1D6DDB;
    border-radius: 40px;
    color: #FFF;
    font-size: 16px;
    margin-bottom: 25px;
    border: none;
  }
  
  .u-btn:after {
      border: none;
  }
  .u-btn[disabled]{
    background-color: #A1C8FF;
  }
}
</style>
